import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'cue-app-version-popup',
  standalone: true,
  templateUrl: './app-version-popup.component.html',
  styleUrl: './app-version-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppVersionPopupComponent {
  visible = input.required<boolean>();
  version = input<string | null>(null);
}
